/**
 * マーク・アイコンマスタ画面のマーク変換情報一覧クラス
 *
 * @export MarkConvInfo
 * @class MarkConvInfo
 */
export class MarkConvInfo {
    constructor(
        public iconCode: string,
        public iconGroupCode: string,
        public iconName: string,
        public iconCodeBranch: string,
        public iconImageUrl: string,
        public markList: {
            markFileName: string,
            markFileUrl: string
        }[]
    ) { }
}
